import { IconChevronDown, IconDots } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import PaddedView from "src/components/UI/PaddedView/PaddedView";
import { useDeviceContext } from "src/context/device-context";
import { useLocaleContext } from "src/context/locale-context";
import classes from "./TopNavigation.module.css";
import { TopRightMenu } from "./elements/TopRightMenu";
import {
  LinkWithQuery,
  NavLinkWithQuery,
} from "src/components/UI/NavLinkWithQuery/NavLinkWithQuery";

const mainNavigation = [
  { name: "main.nav.charters", to: "/charter-flights" },
  { name: "main.nav.airtickets", to: "/" },
  { name: "main.nav.tours", to: "/bus-tours" },
  { name: "main.nav.hotels", to: "/hotels" },
];

// Additional sections that don't fit the four main categories — surfaced under "Papildus".
// Add/remove entries here; the trigger + dropdown render generically off this list.
const additionalNavigation = [
  { name: "main.nav.cheapflights", to: "/cheap-flights" },
  { name: "main.nav.business", to: "/business" },
  { name: "main.nav.groups", to: "/groups" },
];

function MoreNavMenu() {
  const { getStringRes } = useLocaleContext();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const onPointerDown = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    const onKeyDown = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };

    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [isOpen]);

  return (
    <div className={classes.moreMenu} ref={containerRef}>
      <button
        type="button"
        className={classes.moreMenuTrigger}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}>
        <IconDots size={16} stroke={2} />
        {getStringRes("main.nav.more")}
        <IconChevronDown
          size={14}
          stroke={2}
          className={`${classes.moreMenuChevron} ${isOpen ? classes.moreMenuChevronOpen : ""}`}
        />
      </button>
      <div
        className={`${classes.moreMenuDropdown} ${isOpen ? classes.moreMenuDropdownOpen : ""}`}>
        {additionalNavigation.map((item) => (
          <NavLinkWithQuery
            key={item.name}
            to={item.to}
            onClick={() => setIsOpen(false)}
            className={({ isActive }) => (isActive ? classes.active : "")}>
            {getStringRes(item.name)}
          </NavLinkWithQuery>
        ))}
      </div>
    </div>
  );
}

function TopNavigation() {
  const { isMobile } = useDeviceContext();
  const { getStringRes } = useLocaleContext();
  const currentpage = useLocation().pathname;
  const navbarNoBg =
    ["/search/results", "/info/faq", "/search/hotels"].includes(currentpage) ||
    (!isMobile && ["/", "/hotels"].includes(currentpage));

  return (
    <header
      id="main-app-top-nav"
      className={`${classes.menu} ${isMobile ? classes.mobile : classes.desktop} ${
        navbarNoBg ? "" : "opaque"
      } ${["/search/results", "/search/hotels"].includes(currentpage) ? "navResults" : ""}`}>
      <PaddedView>
        <nav className={classes.menuLeft}>
          <LinkWithQuery to={"/"}>
            <img
              className={classes.logo}
              alt="logo"
              src={
                `https://${window.SERVER_DATA.REACT_APP_BUCKET_NAME}.` +
                `${window.SERVER_DATA.REACT_APP_BUCKET_PATH}/static/` +
                `${window.SERVER_DATA.REACT_APP_TENANT_NAME}/en/assets/images/logo.svg`
              }
            />
          </LinkWithQuery>
          {!isMobile &&
            mainNavigation.map((item) => (
              <NavLinkWithQuery
                key={item.name}
                to={item.to}
                className={({ isActive }) => (isActive ? classes.active : "")}>
                {getStringRes(item.name)}
              </NavLinkWithQuery>
            ))}
          {!isMobile && <MoreNavMenu />}
        </nav>
        <TopRightMenu withHeartButton />
      </PaddedView>
    </header>
  );
}

export default TopNavigation;
